exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".online-app-actions{display:flex;flex-direction:row}.online-app-actions .online-app-button{margin-right:10px;height:30px;width:50px;border:0;background:none}.online-app-actions .online-app-button .icon-link{color:green}.online-app-actions .online-app-button .icon-pencil{color:orange}", ""]);

// exports
